var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getLayout,{tag:"component"},[_c('router-view',{key:_vm.$route.name + (_vm.$route.params.person_hash || '')})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }